import { createContext, useContext } from 'react'
import { PracticeRequirementModalState } from './PracticeRequirementModalTypes'

export interface PracticeRequirementModalContextType {
  modalState: PracticeRequirementModalState
  setModalState: (state: PracticeRequirementModalState) => void
}

export const DEFAULT_VALUES = {
  modalState: {
    open: false,
    practice: undefined,
    onClickSelect: (practiceId: string) =>
      console.log('PracticeRequirementModalContext onClickSelect is not defined', practiceId),
  },
  setModalState: () => {},
}

export const PracticeRequirementModalContext =
  createContext<PracticeRequirementModalContextType>(DEFAULT_VALUES)
PracticeRequirementModalContext.displayName = 'PracticeRequirementModalContext'

export const usePracticeRequirementModal = () => useContext(PracticeRequirementModalContext)
